export const CourseData = [
  {
    id: 102,
    title: "Crack Off-Campus Placements",
    image: "PlacementCourseV2.png",
    description:
      "This course is exactly what I wish I had during my final year. After tons of rejections and learnings, I finally cracked my dream role — and packed all those real strategies into this course so you don’t repeat the same mistakes.",
    features: [
      "How to find off-campus roles",
      "Strategy to build your profile",
      "Interview hacks from real experiences",
    ],
    duration: "2 hours",
    language: "Hindi",
    price: 699,
    discountedPrice: 349,
    tags: [
      {
        name: "Tried & Tested",
        color: "bg-yellow-400 text-gray-900",
      },
      {
        name: " Built From My Own Job Hunt",
        color: "bg-[#a78bfa] text-gray-900",
      },
    ],
    cta: "Buy Now",
    link: "/courses/102",
    stats: [
      { value: "500+", label: "Students Enrolled" },
      { value: "4.9", label: "Average Rating" },
      { value: "8+", label: "Hours of Content" },
    ],
  },
  {
    id: 101,
    title: "Mastering Off-Campus Internships",
    image: "course101thumbnail.png",
    description:
      "Struggling to land internships off-campus? This course is built by me after cracking multiple internships without campus help — and now it’s your turn. Learn the exact cold emails, resume formats, and hidden platforms I used to get in.",
    features: [
      "Cold mailing that gets replies",
      "Resume formats that get shortlisted",
      "Top websites & hidden platforms",
    ],
    duration: "2 hours",
    language: "Hindi",
    price: 699,
    discountedPrice: 249,
    tags: [
      {
        name: "High Placement Rate",
        color: "bg-yellow-400 text-gray-900",
      },
      {
        name: "Built By A Mentor Who's Done It",
        color: "bg-[#a78bfa] text-gray-900",
      },
    ],
    cta: "Buy Now",
    link: "/courses/101",
    stats: [
      { value: "500+", label: "Students Enrolled" },
      { value: "4.9", label: "Average Rating" },
      { value: "8+", label: "Hours of Content" },
    ],
  },
  // {
  //   id: 103,
  //   title: "Cracking Off-Campus Marketing Roles",
  //   image: "MarketingCourse.jpg",
  //   description:
  //     "Want to break into marketing but don’t know where to start? This course is built for students aiming to land internships and entry-level roles—without a marketing degree or prior experience. Learn exactly what works in the real world.",
  //   features: [
  //     "Cold mailing & LinkedIn strategies that get replies",
  //     "Portfolio tips for beginners",
  //     "How to choose between agencies and brands",
  //   ],
  //   duration: " 1.5 hours+ Bonus Content",
  //   language: "English",
  //   price: 499,
  //   discountedPrice: 299,
  //   tags: [
  //     {
  //       name: "High ROI for Beginners",
  //       color: "bg-yellow-400 text-gray-900",
  //     },
  //     {
  //       name: "Built by Someone Who’s Done It",
  //       color: "bg-[#a78bfa] text-gray-900",
  //     },
  //   ],
  //   cta: "Buy Now",
  //   link: "/courses/103",
  //   stats: [
  //     { value: "500+", label: "Students Enrolled" },
  //     { value: "4.9", label: "Average Rating" },
  //     { value: "8+", label: "Hours of Content" },
  //   ],
  // },
];
